var NAV_FIXED = (function (my) {
    var _onResizeTimeout,
        _breakpoint_header,
        $html,

        $masthead,
        $breadcrumbs__wrap,
        $headline,
        $slider,
        $main_article,
        $footer,

        $el_fixed,
        $el_fixed__parent,
        $viewport;

    var _onResizeHandler = function() {
        clearTimeout(_onResizeTimeout);
        _onResizeTimeout = setTimeout(_onResize, 20);
    };

    var _onResize = function () {
        console.log('_onResize');

        var windowHeight = $(window).height();

        var mastheadHeight = $masthead.outerHeight() || 0;
        var breadHeight = $breadcrumbs__wrap.outerHeight() || 0;
        var headlineHeight = $headline.outerHeight() || 0;
        var sliderHeight = $slider.outerHeight() || 0;
        var mainarticleHeight = $main_article.outerHeight() || 0;
        var footerHeight = $footer.outerHeight();

        // var headerHeight = $('.main_article').outerHeight();

        var topHeight = parseFloat(mastheadHeight) + parseFloat(breadHeight) + parseFloat(headlineHeight) + parseFloat(sliderHeight);
        var expandedHeight = windowHeight - topHeight - footerHeight;

        $('.sidebar').css({'min-height': mainarticleHeight + 'px'});

        var windowWidth = $(window).width();
        if (windowWidth < _breakpoint_header) {
            $masthead.css({'min-height': '0'});
            $el_fixed__parent.css({'min-height': '0'});
            $el_fixed.removeClass('el_fixed--fixed el_fixed--bottom');

            return;
        }

        var viewportHeight = $('.viewport').outerHeight();
        var mastheadHeight = viewportHeight;

        if (windowHeight - footerHeight > viewportHeight) {
            mastheadHeight = windowHeight - footerHeight;
        }

        $('.sidebar').css({'min-height': mainarticleHeight + 'px'});
        $el_fixed__parent.css({'min-height': mainarticleHeight + 'px'});

        // on scroll
        var fixedElHeight = $el_fixed.height(),
            parentElHeight = $el_fixed__parent.height(),
            paddingBottom = 10,
            scrollTopValue = $(window).scrollTop();

        console.log(scrollTopValue + ' ' + topHeight);

        if (scrollTopValue > topHeight) {
            if (scrollTopValue >= (topHeight + (parentElHeight - fixedElHeight))) {
                $el_fixed
                    .removeClass('el_fixed--fixed')
                    .addClass('el_fixed--bottom');
            } else {
                $el_fixed
                    .removeClass('el_fixed--bottom')
                    .addClass('el_fixed--fixed');
            }
        } else {
            $el_fixed
                .removeClass('el_fixed--bottom')
                .removeClass('el_fixed--fixed');
        }
    };

    my.init = function() {
        console.log('init');
        $html               = $('html'); //

        $masthead           = $('.masthead');
        $breadcrumbs__wrap  = $('.breadcrumbs__wrap');
        $headline           = $('.headline');
        $slider             = $('.slider__container');
        $main_article       = $('.main_article'); //
        $footer             = $('.footer'); //

        $viewport           = $('.sidebar');
        $el_fixed           = $('.el_fixed'); //
        $el_fixed__parent   = $('.el_fixed__parent'); //


        $(window).on('resize orientationchange', _onResizeHandler); // execute after timeout
        $(window).on('scroll', _onResize); // immediate execution

        _onResize();

        $(document).on('load lazyloaded', function(){
            _onResize();
        });

        $('body').imagesLoaded(function() {
            _onResize();
        });
    };

    my.onResize = _onResize;

    return my;

}(NAV_FIXED || {}));

(function ($) {
    'use strict';

    /**
     * Ajax related behaviour related to "add to cart", "remove from cart", "etc"
     */
    $(function () {
        NAV_FIXED.init();
    });

}(jQuery));